import SpotlightActionButtons from './SpotlightActionButtons'

export default SpotlightActionButtons
// eslint-disable-next-line import/export
export * from './SpotlightActionButtons'
